import * as React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import BackButton from "../../Components/Headers/Components/BackButton";

import { useHeaderContext } from "@/context/header/useHeaderContext";
import { type MediaPermissionScreenState } from "@/schemas/screen/configs";
import { MediaPermissionTabs, Screen } from "@/schemas/screen/tabs";

function ManageAccessHeader(): React.JSX.Element {
  const { currentScreen, setCurrentScreen } = useHeaderContext();

  const handleTabPress = (tab: MediaPermissionTabs): void => {
    const newScreenConfig: MediaPermissionScreenState = {
      screenId: Screen.MEDIA_PERMISSION,
      activeTabId: tab,
      filters: null,
    };
    setCurrentScreen(newScreenConfig);
  };

  return (
    <SafeAreaView style={styles.safeArea} edges={["top"]}>
      <View style={styles.container}>
        <View style={styles.sideContainer}>
          <BackButton />
        </View>
        <View style={styles.tabsWrapper}>
          <View style={styles.tabsContainer}>
            <TouchableOpacity
              style={styles.tab}
              hitSlop={8}
              onPress={() => handleTabPress(MediaPermissionTabs.REQUESTED)}
            >
              <Text
                style={[
                  styles.tabText,
                  currentScreen.activeTabId === MediaPermissionTabs.REQUESTED &&
                    styles.activeTabText,
                ]}
              >
                Requested
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.tab}
              hitSlop={8}
              onPress={() => handleTabPress(MediaPermissionTabs.APPROVED)}
            >
              <Text
                style={[
                  styles.tabText,
                  currentScreen.activeTabId === MediaPermissionTabs.APPROVED &&
                    styles.activeTabText,
                ]}
              >
                Approved
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={styles.sideContainer} />
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    backgroundColor: "#fff",
  },
  container: {
    alignItems: "center",
    backgroundColor: "#fff",
    flexDirection: "row",
    paddingHorizontal: 10,
    height: 45,
  },
  sideContainer: {
    flex: 1,
    alignItems: "flex-start",
  },
  tabsWrapper: {
    alignItems: "center",
    flex: 4,
  },
  tabsContainer: {
    flex: 1,
    alignItems: "center",
    flexDirection: "row",
    gap: 5,
  },
  tab: {
    flex: 1,
    alignItems: "center",
    transform: [{ translateX: -5 }], // shift tabs slightly to the left for better visual balance with back button
  },
  tabText: {
    color: "#888",
    fontSize: 20,
  },
  activeTabText: {
    color: "#000",
    fontWeight: "bold",
  },
});

export default ManageAccessHeader;
